import type { CampaignsFilter } from '@/types';
import type { SelectProps } from 'antd';
import { Flex, Grid, theme } from 'antd';
import { MultiSelectEcho } from '@/components/echo/primitives';

export type TableFiltersData = {
  shows: {
    id: string;
    name: string;
  }[];
  campaign_types: string[];
  advertisers: string[];
};

type FilterType = 'show' | 'advertiser' | 'campaign_type';

type TableFiltersProps = {
  showOptions: { value: string; label: string }[];
  advertiserOptions: { value: string; label: string }[];
  campaignTypeOptions: { value: string; label: string }[];
  handleSetFilterState: React.Dispatch<React.SetStateAction<CampaignsFilter>>;
  onFilterOpen?: (filterType: FilterType) => void;
  onFilterChange?: (filterType: FilterType, ids: string[]) => void;
};

const TableFiltersEcho = ({
  showOptions,
  advertiserOptions,
  campaignTypeOptions,
  handleSetFilterState,
  onFilterOpen,
  onFilterChange,
}: TableFiltersProps) => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();

  const isMdUp = !!screens.md;

  const filterSelectStyles: NonNullable<SelectProps['styles']> = {
    root: {
      flex: '1 1 0%',
      minWidth: 224,
      maxWidth: isMdUp ? 352 : '100%',
    },
  };

  return (
    <Flex
      vertical={!isMdUp}
      gap={token.margin}
      justify={isMdUp ? 'flex-end' : undefined}
      style={{
        marginTop: token.marginLG,
        transform: `translateY(-${token.marginXS}px)`,
      }}
    >
      {showOptions.length > 1 && (
        <MultiSelectEcho
          showSearch={{ optionFilterProp: 'label' }}
          allowClear
          placeholder="Show: All"
          options={showOptions}
          maxTagCount="responsive"
          styles={filterSelectStyles}
          onOpenChange={(open) => {
            if (open) onFilterOpen?.('show');
          }}
          onChange={(values: string[]) => {
            onFilterChange?.('show', values);
            handleSetFilterState((currentState: CampaignsFilter) => ({
              ...currentState,
              showId: values,
            }));
          }}
        />
      )}
      <MultiSelectEcho
        showSearch={{ optionFilterProp: 'label' }}
        allowClear
        placeholder="Advertiser: All"
        options={advertiserOptions}
        maxTagCount="responsive"
        styles={filterSelectStyles}
        onOpenChange={(open) => {
          if (open) onFilterOpen?.('advertiser');
        }}
        onChange={(values: string[]) => {
          onFilterChange?.('advertiser', values);
          handleSetFilterState((currentState: CampaignsFilter) => ({
            ...currentState,
            advertiserName: values,
          }));
        }}
      />
      <MultiSelectEcho
        showSearch={{ optionFilterProp: 'label' }}
        allowClear
        placeholder="Campaign type: All"
        options={campaignTypeOptions}
        maxTagCount="responsive"
        styles={filterSelectStyles}
        onOpenChange={(open) => {
          if (open) onFilterOpen?.('campaign_type');
        }}
        onChange={(values: string[]) => {
          onFilterChange?.('campaign_type', values);
          handleSetFilterState((currentState: CampaignsFilter) => ({
            ...currentState,
            campaignType: values,
          }));
        }}
      />
    </Flex>
  );
};

export default TableFiltersEcho;
